import { Component, OnInit, Input, Type, OnDestroy, ViewChild, NgZone, AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { EntityListAction, Permission, form_control } from 'projects/sepidz-web-framework/src/lib/models';

import {
  CancelEvent,
  EditEvent,
  TreeListComponent,
} from '@progress/kendo-angular-treelist';
import { RowState } from 'projects/sepidz-web-framework/src/lib/models/enums';
import { ShowToastrService, HttpCommonService, Utilities, GridFilter, AccountService } from 'projects/sepidz-web-framework/src/lib/services';

import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DialogType } from 'projects/sepidz-web-framework/src/lib/models/dialog.enum';
import { SimpleModalService } from 'projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service';

@Component({
  selector: 'editabel-treelist',
  templateUrl: './editabeltreelist.component.html',
  styleUrls: ['./editabeltreelist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditabeltreelistComponent implements OnInit, OnDestroy, AfterContentInit {
  isRefreshing: boolean = false;
  formGroup: UntypedFormGroup;
  public editedItem: any;
  ngUnsubscribe = new Subject<void>();
  @Input() label: string;
  @Input() apiName: string;
  @Input() inputEditorform: Type<any>;
  @Input() name: string;
  @Input() IdName: string;
  @Input() ParentIdName: string;
  @Input() expandableField: string;
  _dataList: any[];
  treelistIsLoaded: boolean = false;
  @Input()
  get dataList(): any[] {
    return this._dataList;
  }
  set dataList(value: any[]) {
    if (value && this._dataList !== value && value.length > 0)
      setTimeout(() => this.fitColumns(), 200);
    this._dataList = value;
  }
  _actions: any[] = [];
  get validactions() {
    return this._actions;
  }
  @Input() columns: form_control[] = [];
  @ViewChild(TreeListComponent)
  public treelist: TreeListComponent;
  @Input() actions: any[];
  @Input() actionTregger: (
    action: EntityListAction
  ) => void;
  constructor(private sts: ShowToastrService,
    private _httpCommonService: HttpCommonService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private accountService: AccountService,
    public dialogService: SimpleModalService) {
  }
  ngAfterContentInit(): void {
    this.fitColumns();
  }

  toFormGroup(entity: any = null, parent: any = null) {
    let group: any = {};
    if (parent) {
      group[this.ParentIdName] = new UntypedFormControl(parent ? parent[this.IdName] : null);
    } else
      group[this.ParentIdName] = new UntypedFormControl(entity ? entity[this.ParentIdName] : null);
    this.columns.forEach(question => {
      switch (question.textType) {
        case ("text"):
          group[question.name] = question.required ? new UntypedFormControl(!entity ? '' : entity[question.name] || '', Validators.required)
            : new UntypedFormControl(!entity ? '' : entity[question.name] || '');
          break;
        case ("checkbox"):
          group[question.name] = question.required ? new UntypedFormControl(!entity ? false : entity[question.name] || false, Validators.required)
            : new UntypedFormControl(!entity ? false : entity[question.name] || false);
          break;
        case ("number"):
          group[question.name] = question.required ? new UntypedFormControl(!entity ? 0 : entity[question.name], Validators.required)
            : new UntypedFormControl(!entity ? 0 : entity[question.name]);
          break;
        case ("date"):
          group[question.name] = question.required ? new UntypedFormControl(!entity ? new Date() : entity[question.name] || new Date(), Validators.required)
            : new UntypedFormControl(!entity ? new Date() : entity[question.name] || new Date());
          break;
        default:
          group[question.name] = question.required ? new UntypedFormControl(!entity ? '' : entity[question.name] || '', Validators.required)
            : new UntypedFormControl(!entity ? '' : entity[question.name] || '');
          break;
      }
    });

    group["State"] = new UntypedFormControl(!entity ? RowState.New : entity["State"] || RowState.NoChange);
    group["Id"] = new UntypedFormControl(!entity ? 0 : entity["Id"] || 0);
    group["RowVersion"] = new UntypedFormControl(!entity ? '' : entity["RowVersion"] || '');
    let fg = new UntypedFormGroup(group);

    this.cd.detectChanges();
    return fg
  }
  public ngOnInit(): void {
    if (!this.dataList)
      this.dataList = [];
    if (this.apiName) {
      this.setColumns();
      this.refreshData();
    }
    this.setvalidactions();
  }
  setvalidactions() {
    if (!this.actions) return this.actions;
    var list = this.actions.filter((x) =>
      this.accountService.userHasPermission(`${x.areaName}:${x.apiName}`, x.permission ? x.permission : Permission.managePermission)
    );
    this._actions = list;
  }
  rootData: any[];

  public fetchChildren = (item: any): any[] => {
    return this.dataList.filter(x => x[this.ParentIdName] === item[this.IdName]);
  }
  gethasChildren(item: any): boolean {
    return this.dataList && this.dataList.filter(x => x[this.ParentIdName] === item[this.IdName]).length > 0;
  }
  public hasChildren = (item: any): boolean => {
    return this.gethasChildren(item);
  }
  onToolbarItemClick(action: EntityListAction) {
    if (document.hidden) return;
    if (this.actionTregger && !action.disabled) {
      this.actionTregger(action);
      return;
    }
  }
  public addHandler({ sender, parent }): void {
    if (this.apiName) {
      this.dialogService.open(this.inputEditorform, {
        currentrow: null,
        apiName: this.apiName,
        parentrow: parent,
        label: this.label,
      }, {
        autoFocus: true,
        closeOnClickOutside: false,
        closeOnEscape: false,
      })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(model => {
          this.isRefreshing = true;
          setTimeout(() => this.refreshData(), 500);
        });
      this.cd.detectChanges();
      return;
    }
    // Close the current edited row, if any.
    this.closeEditor(!sender ? this.treelist : sender);
    // Expand the parent.
    if (parent) {
      sender.expand(parent);
    }
    this.formGroup = this.toFormGroup(null, parent);
    // Show the new row editor, with the `FormGroup` build above
    if (sender)
      sender.addRow(this.formGroup, parent);
    else
      this.treelist.addRow(this.formGroup, parent);
    this.cd.detectChanges();
  }

  public editHandler({ sender, dataItem }: EditEvent): void {
    if (this.apiName) {
      this.dialogService.open(this.inputEditorform, {

        currentrow: dataItem,
        apiName: this.apiName,
        label: this.label
      }, {
        autoFocus: true,
        closeOnClickOutside: false,
        closeOnEscape: false,
      })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(model => {
          this.isRefreshing = true;
          setTimeout(() => this.refreshData(), 500);
        });
      return;
    }
    // Close the current edited row, if any.
    this.closeEditor(sender, dataItem);
    this.formGroup = this.toFormGroup(dataItem);
    this.editedItem = dataItem;

    // Put the row in edit mode, with the `FormGroup` build abovehasChildren
    sender.editRow(dataItem, this.formGroup);
    this.cd.detectChanges();
  }

  public cancelHandler({ sender, dataItem, isNew }: CancelEvent): void {
    // Close the editor for the given row
    this.closeEditor(sender, dataItem, isNew);
    this.cd.detectChanges();
  }

  public saveHandler({ sender, dataItem, parent, formGroup, isNew }): void {
    const entity: any = formGroup.value;

    if (!isNew) {
      Object.assign(dataItem, entity);
    } else if (parent) {
      //entity.Parent = parent;
      entity[this.IdName] = this.dataList.length + 1;
      entity[this.ParentIdName] = parent[this.IdName];
    }

    if (isNew) {
      entity.State = RowState.New;
      if (!parent)
        entity[this.ParentIdName] = undefined;
      entity[this.IdName] = this.dataList.length + 1;
      //if (!parent)
      this.dataList.push(entity);
    }
    else {
      this.dataList.forEach(x => {
        if (x[this.IdName] === entity[this.IdName]) {
          if (x.State != RowState.New)
            x.State = RowState.Modify;
          x = entity;
        }
      })
    }
    if (parent) {
      sender.reload(parent);
    }
    sender.closeRow(dataItem, isNew);
    this.rootData = this.dataList.filter(x => !x[this.ParentIdName]);
    this.cd.detectChanges();
  }
  deleteFormHelper(row: any) {
    this.isRefreshing = true;
    this.sts.showToast('primary', '', 'در حال حذف...');
    this._httpCommonService.delete(this.apiName, row.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(results => {
        this.sts.showToast('success', '', 'اطلاعات با موفیت حذف شد.');
        setTimeout(() => this.refreshData(), 200);
      },
        error => {
          this.isRefreshing = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, 'خطا در حذف اطلاعات');
        });
    this.cd.detectChanges();
  }
  public removeHandler({ sender, dataItem, parent }): void {
    if (this.apiName) {
      this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, 'حذف اطلاعات', DialogType.confirm, () => this.deleteFormHelper(dataItem));
    }
    else {
      if (dataItem)
        this.dataList.splice(this.dataList.indexOf(dataItem), 1);
      else
        this.dataList.splice(this.dataList.indexOf(parent), 1);
    }
    if (parent)
      sender.reload(parent);
    else
      sender.reload(dataItem);
    this.rootData = this.dataList.filter(x => !x[this.ParentIdName]);
    this.cd.detectChanges();
  }

  private closeEditor(treelist: TreeListComponent, dataItem: any = this.editedItem, isNew: boolean = false): void {
    treelist.closeRow(dataItem, isNew);
    this.editedItem = undefined;
    this.formGroup = undefined;
    this.cd.detectChanges();
  }
  refreshData() {
    this.isRefreshing = true;
    this.sts.showToast('primary', '', 'در حال بارگذاری اطلاعات...');
    this._httpCommonService.getList(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data != undefined) {
          this.dataList = data as any[]
          this.sts.showToast('success', '', 'اطلاعات با موفقیت بارگذاری شد.');
          this.isRefreshing = false;
          this.rootData = this.dataList.filter(x => !x[this.ParentIdName]);
          this.cd.detectChanges();
        }
      },
        error => {
          this.isRefreshing = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, 'خطا در حذف اطلاعات');
        });
  }

  setColumns() {
    this._httpCommonService.getControlsList(this.apiName.split('/')[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.columns = (data as form_control[]).sort((a, b) => a.order - b.order);
          this.setColumnWith();
        }
      });
  }
  setColumnWith() {
    this.columns.forEach(x => {
      if (x.textType === 'number' && x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID"))
        x.format = '#,#.#####';
      else
        x.format = '';
      if (!x.maxLength || x.maxLength <= 0) {
        if (x.textType === "text")
          x.maxLength = 200;
        else
          x.maxLength = 100;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this._dataList = undefined;
  }
  fitColumns(): void {
    this.cd.detectChanges();
    if (this.treelist)
      setTimeout(() =>
        this.ngZone.onStable.asObservable().pipe(take(1))
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(() => {
            this.treelist.autoFitColumns()
          })
        , 200);
  }
}
